// Footer.jsx - Updated responsive component
import React from "react";
import { animateScroll as scroll } from "react-scroll";
import { FaCubes } from "react-icons/fa";

import {
  FooterContainer,
  FooterWrap,
  FooterLink,
  FooterLinkItems,
  FooterLinksWrapper,
  FooterLinkTitle,
  FooterLinkHead,
  SocialMedia,
  SocialMediaWrap,
  SocialLogo,
} from "./FooterElements";
import Socials from "../Socials/Socials";

function Footer() {
  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <>
      <FooterContainer>
        <FooterWrap>
          <FooterLinksWrapper>
            <FooterLinkItems description>
              <FooterLinkHead>
                I design and engineer scalable digital products, web platforms,
                and intelligent systems that transform ideas into real-world
                impact. From concept to launch, I focus on building solutions
                that are reliable, growth-ready, and built to solve meaningful
                problems.
              </FooterLinkHead>
            </FooterLinkItems>
            <FooterLinkItems>
              <FooterLinkTitle>Links</FooterLinkTitle>
              <FooterLink
                to="about"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                offset={-80}
              >
                About
              </FooterLink>
              <FooterLink
                to="services"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                offset={-80}
              >
                Services
              </FooterLink>
              <FooterLink
                to="portfolio"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                offset={-80}
              >
                Portfolio
              </FooterLink>
              <FooterLink
                to="contact"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                offset={-80}
              >
                Contacts
              </FooterLink>
            </FooterLinkItems>
          </FooterLinksWrapper>

          <SocialMedia>
            <SocialMediaWrap>
              <SocialLogo to="/" onClick={toggleHome}>
                <FaCubes /> vuni
              </SocialLogo>
              <Socials />
            </SocialMediaWrap>
          </SocialMedia>
        </FooterWrap>
      </FooterContainer>
    </>
  );
}

export default Footer;
